import { Form, Modal, Input, Select, Button, InputNumber } from "antd";
import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getDirectusClient } from "../../../lib/directus";
import { createItem, readItems, readUsers } from "@directus/sdk";

const { Option } = Select;

function AddDescuento({ openadd, addModal, getDescuentos }) {
  const [form] = Form.useForm();
  const [usuarios, setUsuarios] = useState([]);
  const [productos, setProductos] = useState([]);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);

  const getUsuarios = useCallback(async () => {
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readUsers({
          fields: ["*", "role.*", "bodega.*", "first_name", "last_name"],
          filter: {
            _and: [
              {
                role: {
                  name: {
                    _eq: "vendedor rutas",
                  },
                },
              },
              {
                bodega: {
                  id: {
                    _eq: userBodega,
                  },
                },
              },
            ],
          },
        })
      );
      
      setUsuarios(response);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  }, [userBodega]);

  const getProductos = useCallback(async () => {
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readItems("productos", {
          fields: ["*", "nombre", "id", "grupo.*"],
          sort: ["nombre"],
        })
      );
    
      setProductos(response);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  }, []);

  useEffect(() => {
    getUsuarios();
    getProductos();
  }, [getUsuarios, getProductos]);

  const onFinish = async (values) => {
    const directus = await getDirectusClient();
    directus
      .request(
        createItem("descuentos", {
          nombre: values.nombre,
          descuento: values.descuento,
          usuarios: values.usuarios.map((userId) => ({
            directus_users_id: { id: userId },
          })),
          productos: values.productos,
        })
      )
      .then(() => {
        getDescuentos();
        onReset();
        addModal();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <Modal
      title="Crear Descuento"
      open={openadd}
      onCancel={addModal}
      footer={false}
    >
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{
          maxWidth: 600,
        }}
      >
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[
            {
              required: true,
              message: "Por favor ingrese el nombre del descuento",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="descuento"
          label="Descuento (%)"
          rules={[
            {
              required: true,
              message: "Por favor ingrese el porcentaje de descuento",
            },
          ]}
        >
          <InputNumber
            min={0}
            precision={5} 
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          name="usuarios"
          label="Usuarios"
          rules={[
            {
              required: true,
              message: "Por favor seleccione al menos un usuario",
            },
          ]}
        >
          <Select
        
            placeholder="Seleccione usuarios"
            allowClear
            style={{ width: "100%" }}
          >
            {usuarios.map((usuario) => (
              <Option key={usuario.id} value={usuario.id}>
                {usuario.first_name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="productos"
          label="Productos"
          rules={[
            {
              required: true,
              message: "Por favor seleccione un producto",
            },
          ]}
        >
          <Select
            placeholder="Seleccione un producto"
            allowClear
            style={{ width: "100%" }}
          >
            {productos.map((producto) => (
              <Option key={producto.id} value={producto.id}>
                {producto.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Crear
          </Button>
          <Button htmlType="button" onClick={onReset} style={{ marginLeft: 8 }}>
            Limpiar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

AddDescuento.propTypes = {
  openadd: PropTypes.bool.isRequired,
  addModal: PropTypes.func.isRequired,
  getDescuentos: PropTypes.func.isRequired,
};

export default AddDescuento;
